// src/components/HomePage.js
import React from 'react';
import SEOHead from './SEOHead';

function HomePage() {
  return (
    <div>
      <SEOHead />
      {/* 기존의 h1, 카테고리 링크 등 모두 삭제 */}
    </div>
  );
}

export default HomePage;